<template>
    <rkm-table
        :fields="fields"
        :items="data.model.medicamentos"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(actions)="{item, index}">
            <rkm-button
                :disabled="!!item.automatico"
                @click="destroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

export default {
    data: () => ({
        fields: [
            {key: 'descricaoCompleta', label: 'Nome', sortable: true},
            {key: 'quantidade', label: 'Quantidade', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o medicamento?', async () => {
                this.data.model.medicamentos.splice(index, 1)
            })
        },
    },
    mixins: [formats],
    props: {
        data: {type: Object, required: true},
    },
}
</script>